/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { GuestCounter, FlexRow, FlexCol, FauxLabel } from 'sarsaparilla';
import TripDates from './TripDates';

const propTypes = {
    trip: PropTypes.object,
    onChange: PropTypes.func,
};

const defaultProps = {};

export default class TripDestinationHeaderItem extends React.Component {
    constructor(props) {
        super(props);

        this.guestTypes = [
            {
                key: 'adult',
                type: 'Adult',
                description: 'ages 13+',
                count: 0,
            },
            {
                key: 'youth',
                type: 'Youth',
                description: 'ages 9 - 12',
                count: 0,
            },
            {
                key: 'access',
                type: 'Access',
                description: 'no age required',
                count: 0,
            },
            {
                key: 'senior',
                type: 'Senior',
                description: 'ages 65+',
                count: 0,
            },
        ];
        this.initCounts(this.props.trip);
        this.onCountChange = this.onCountChange.bind(this);
    }

    onCountChange(counts) {
        this.props.trip.guest_counts = counts;
        if (this.props.onChange) {
            this.props.onChange(this.props.trip);
        }
    }

    initCounts(trip) {
        if (trip) {
            this.guestTypes.forEach((t) => {
                const guestType = t;
                const count = trip.guest_counts[guestType.key];
                guestType.count = count;
            });
        }
    }

    render() {
        return (
            <FlexRow className="trip-planner-start-and-guests mt-2">
                <FlexCol md={6} className="trip-planner-dates">
                    <TripDates trip={this.props.trip} onApply={this.props.onChange} />
                </FlexCol>

                <FlexCol md={6} className="trip-planner-guests">
                    <div className="rec-form-item-wrap">
                        <FauxLabel className="mb-half">How Many People</FauxLabel>
                        <GuestCounter
                            label="Guests"
                            title={'Guests'}
                            guestTypes={this.guestTypes}
                            onCountChange={this.onCountChange}
                        />
                    </div>
                </FlexCol>
            </FlexRow>
        );
    }
}

TripDestinationHeaderItem.propTypes = propTypes;
TripDestinationHeaderItem.defaultProps = defaultProps;
